module.exports = __webpack_public_path__ + "static/media/21-7.d719a59a.mp3";